import semver from "semver";
export function stringifyVersion(fields) {
    return `${fields.major}.${fields.minor}.${fields.patch}`;
}
export function parseVersion(version) {
    const coercedVersion = semver.coerce(version);
    if (coercedVersion === null) {
        return null;
    }
    return {
        major: coercedVersion.major,
        minor: coercedVersion.minor,
        patch: coercedVersion.patch
    };
}
//# sourceMappingURL=versioning.js.map